import { Snackbar, Alert } from "@mui/material";
// import { Slide } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

import { useDispatch, useSelector } from "react-redux";

const WarningBar = ({ children }) => {
  const dispatch = useDispatch();
  const { open, message } = useSelector((state) => state.warning);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    dispatch({ type: "DISMISS_WARNING_MESSAGE" });
  };

  return (
    <div>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
        sx={{ width: "100%", top: "48px !important" }}
        // TransitionComponent={(props) => <Slide {...props} direction="down" />}
      >
        <Alert
          icon={<InfoIcon fontSize="inherit" sx={{ color: "#403200" }} />}
          onClose={handleClose}
          severity="warning"
          sx={{ width: "100%", backgroundColor: "#FFF5CA", color: "#403200" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default WarningBar;
